module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "About.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-4"
  }, [_c('p', {
    staticClass: "image-fr"
  }, [_c('span', {
    staticClass: "a-head-italics"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "beea.tif",
      "src": "images/beea_fmt.png",
      "width": "10%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "x1about-xsc",
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('span', {
    staticClass: "a-head-italics",
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("about the "), _c('br')]), _vm._v("Author")]), _vm._v(" "), _c('p', {
    staticClass: "no-indent"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("Ellen Dugan")]), _vm._v(", also known as the Garden Witch, is a psychic-clairvoyant who lives in Missouri with her husband and three children. A practicing Witch for over twenty-five years, Ellen also has many years of nursery and garden center experience, including landscape and garden design. She received her Master Gardener status through the University of Missouri and her local county extension office. Look for other articles by Ellen in Llewellyn’s annual "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Magical Almanac")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Witches’ Companion")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herbal Almanac")]), _vm._v(", and visit her website at: "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("www.ellendugan.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-fl"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "beeb.tif",
      "src": "images/beeb_fmt.png",
      "width": "15%"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b468657","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 60
// module chunks = 0